import * as React from "react";

import {FBParagraphOptions} from "./FBParagraph.Options";
import {FBFieldBase, FBFieldBaseProps, FBFieldBaseState} from "FormBuilder/Fields/Core/FBFieldBase";
import {FBParagraphModel} from "./FBParagraph.Model";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {EventManager} from "shared/core/Events/EventManager";


export class FBParagraph extends FBFieldBase<FBParagraphProps,FBDropDownState>{

    static defaultProps: Partial<FBParagraphProps> = {

    };

    constructor(props: FBParagraphProps) {
        super(props);
        this.state = {

        };




    }


    SubRender() {
        if(this.Model.Options.Label.trim()==''&&this.Model.Options.Text.trim()=='')
        {
            if(rednaoProductDesigner!=null&&rednaoProductDesigner.IsDesign)
            {
                return (
                    <div className={'rnParagraphField'} style={{padding:10}}>
                        Empty Paragraph Field
                    </div>
                );
            }
        }
        return(
            <React.Fragment>
                {<div className={'rnParagraphField'}>
                    {this.GetLabel()}
                    <div dangerouslySetInnerHTML={{__html:this.Model.Options.Text}}></div>
                </div>
                }
            </React.Fragment>
        )


    }


    protected InternalSerialize(obj: object) {
        return null;
    }

    GetStoresInformation(): boolean {
        return false;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBParagraphProps extends FBFieldBaseProps{
    Model:FBParagraphModel;

}

interface FBDropDownState extends FBFieldBaseState{

}





EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.Paragraph)
        return new FBParagraphModel(event.Options as FBParagraphOptions,event.parent).Initialize(event.PreviousData);
});


EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.Paragraph)
        return new FBParagraphOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.Paragraph)
        return <FBParagraph Model={event.Model as FBParagraphModel} />
});

//#endregion "My Region"